import styled from 'styled-components';

import AirlineImg from 'components/AirlineLogo';
import StyledButton from 'components/Buttons/Button';
import CheckBox from 'components/Checkbox';
import List from 'components/List';
import ListItem from 'components/List/ListItem';

export const Container = styled.main`
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background-color: ${({ theme }) => theme.airlinesList.background};
`;

export const Body = styled.section`
  padding: 16px;
`;

export const AirlineList = styled(List)`
  padding: 0;
  margin: 0 0 40px 0;
`;

export const AirlinesListItem = styled(ListItem)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 32px;
  width: 100%;
  height: 80px;
  box-shadow: none;
  border-bottom: solid 1px ${({ theme }) => theme.airlinesList.border};

  & div {
    display: flex;
    align-items: center;
  }

  & p {
    font-size: 16px;
    font-weight: 600;
    font-stretch: normal;
    font-style: normal;
    line-height: 5;
    letter-spacing: normal;
    color: ${({ theme }) => theme.airlinesList.textColor};
  }
`;

export const Check = styled(CheckBox)`
  & span {
    width: 20px;
    min-width: 20px;
    height: 20px;
  }
`;

export const AirlineLogo = styled(AirlineImg)`
  max-width: 26px;
  max-height: 26px;
  margin-right: 18px;
`;

export const ButtonContainer = styled.section`
  position: sticky;
  width: 100%;
  bottom: 16px;
`;

export const Button = styled(StyledButton)`
  font-size: 16px;
  font-weight: 600;
`;
